import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchUserInfo, refreshToken } from "./features/userSlice";
import RoutesComponent from "./routes/routes";
import { CompanyProvider } from './features/CompanyContext';

function App() {
  const dispatch = useDispatch();
  const [isLogged, setIsLogged] = useState(false);
  const [isAuthResolved, setIsAuthResolved] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const bootstrapAuth = async () => {
      try {
        // Primero intentamos recuperar la sesión con el accessToken actual.
        await dispatch(fetchUserInfo()).unwrap();
        if (isMounted) {
          setIsLogged(true);
        }
      } catch (meError) {
        try {
          // Si falla, intentamos refrescar y volver a pedir la información del usuario.
          await dispatch(refreshToken()).unwrap();
          await dispatch(fetchUserInfo()).unwrap();
          if (isMounted) {
            setIsLogged(true);
          }
        } catch (refreshError) {
          if (isMounted) {
            setIsLogged(false);
          }
        }
      } finally {
        if (isMounted) {
          setIsAuthResolved(true);
        }
      }
    };

    bootstrapAuth();

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  return (
      <div className="App">
        <CompanyProvider>
          <RoutesComponent shouldRedirect={isLogged} isAuthResolved={isAuthResolved} />
        </CompanyProvider>
      </div>
  );
}

export default App;
